var map = {
	"./alfamart-light.png": "2661",
	"./bca-light.png": "fd56",
	"./bcas-light.png": "69df",
	"./bcava-light.png": "08c7",
	"./bni-light.png": "99f5",
	"./bniva-light.png": "1d55",
	"./bri-light.png": "582e",
	"./briva-light.png": "dee0",
	"./bsi-light.png": "d4a5",
	"./bsiva-light.png": "9b31",
	"./indomaret-light.png": "7423",
	"./mandiri-light.png": "96c5",
	"./mandiriva-light.png": "65b0",
	"./permatava-light.png": "43c9",
	"./qris-light.png": "8649"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f2cf";